import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import AppSidebar from "./scenes/global/AppSidebar";
import Dashboard from "./scenes/dashboard";
import Invoices from "./scenes/invoices";
import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Books from "./scenes/books";
import AddBook from "./scenes/addBook";
import Login from "./scenes/login";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import AddEvent from "./scenes/addEvent";
import AddGalleryItem from "./scenes/addGalleryItem/addGalleryItem";
import ReviewsPage from "./scenes/reviews/ReviewsPage";
import LeadsPage from "./scenes/leads/LeadsPage";

function App() {
  const [theme, colorMode] = useMode();
  const [isAppSidebar, setIsAppSidebar] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("adminToken"),
  );

  const handleLogin = () => setIsLoggedIn(true);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    setIsLoggedIn(false);
  };

  if (!isLoggedIn) {
    return (
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </ThemeProvider>
      </ColorModeContext.Provider>
    );
  }

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <AppSidebar isAppSidebar={isAppSidebar} />
          <main className="content">
            <Topbar setIsAppSidebar={setIsAppSidebar} onLogout={handleLogout} />
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/books" element={<Books />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/bar" element={<Bar />} />
              <Route path="/pie" element={<Pie />} />
              <Route path="/line" element={<Line />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/add-book" element={<AddBook />} />
              <Route path="/add-event" element={<AddEvent />} />
              <Route path="/add-gallery-item" element={<AddGalleryItem />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/leads" element={<LeadsPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
